(function() {
	'use strict';

	/**
	 * Service for managing the User. (auth, database)
	 * @TODO try to get fullySync plugin to work
	 * @TODO cancel replication when user logs out
	 */

	angular
		.module("pwc.pouch.system")
		.service("systemPouch", systemPouch);

	systemPouch.$inject = ['$window', '$q', 'pouchDB', 'lodash', '$log', 'ENV', 'Utils', 'DialogService'];

	function systemPouch($window, $q, pouchDB, lodash, $log, ENV, Utils, DialogService){

		/* jshint validthis: true */
		var self = this;

		self.apiURL = ENV.COUCH_URL;

		// To prevent browser HTTP basic authentication modal dialogs of ye olde times, we have to be subtle in the way we use PouchDB.
		// To prevent a rogue unauthenticated request to CouchDB (used to check whether the remote DB exists), pass skipSetup: true.
		self.remote = pouchDB(self.apiURL + '/pwc', {
			skip_setup: true,
			skipSetup: true,
            ajax: {
                timeout: 120000
            }
		});

		self.local = null;

		// local to remote pouch sync handler
		self.syncHandler = {};

		/**
		 * Constructor / Initialization
		 */

		initialize();

		/**
		 * Begin methods
		 */

		function initialize(){
			self.local = initializeSystemDb();
		}

		function initializeSystemDb(){

			// on Safari, we need to make a big ask up-front for 500M
			// Sadly, iOS is limited to 50
			var size = Utils.agent.isIOS() ? 50 : 500;

			var opts = {
				size: size,
				"auto_compaction": true
			};

			$log.debug('PouchDB opts', opts);

			return pouchDB('pwc_system_db', opts);
		}

		function getApiURL(){
			return self.apiURL;
		}

		function getRemoteDatabase(){
			return self.remote;
		}

		function getLocalDatabase(){
			return self.local;
		}

		function getSyncHandler(){
			return self.syncHandler;
		}

		function onChange(response) {
			$log.debug('Changes made to the PWC db.', response);

            if (lodash.get(response, 'docs')){
                lodash.forEach(response.docs, function(doc, key) {
                    if (doc._id === 'version'){
                        $log.debug('Version has changed');

						DialogService.versionOutOfDate();
                    }
                });
            }
		}

		function onError(err) {
			$log.debug('PWC db error', err);
		}

		function onComplete(){
			$log.debug('Done syncing PWC db.');
		}

		function onPaused(info){
			$log.debug('PWC db replication on pause.');
		}

		function onActive(info){
			$log.debug('PWC db replication resumed.');
		}

		function findByType(type){
			return self.local.allDocs({
				"include_docs": true,
				"startkey": type + '/',
				"endkey": type + '/\uffff'
			}).then(function(res){
				return lodash.pluck(res.rows, 'doc');
			});
		}

		function startReplication(){

			$log.debug('Setting up replication for PWC db.');

			if (! lodash.isEmpty(self.syncHandler)){
				$log.debug('Sync handler for system already active.');
				return false;
			}

			// 1 way replication
			self.syncHandler = $window.PouchDB.replicate(self.remote, self.local, {
                timeout: 0,
				conflicts: false,
				batch_size: 200,
				batches_limit: 1,
				live: true,
				retry: true // @TODO change - ConnectionService is used to start/cancel replication
			});

			$log.debug('Starting one-way replication for PWC...', self.syncHandler);

			self.syncHandler.on('change', onChange)
				.on('error', onError)
				.on('complete', onComplete)
				.on('paused', onPaused)
				.on('active', onActive);
		}

        /**
		 *
         * @returns Promise
         */
		function cancelReplication(){
			if (! lodash.isEmpty(self.syncHandler)) {
				$log.debug('Cancelling replication / synchronization of PWC db...');

				return $q.when(self.syncHandler.cancel());
			}

			return $q.when(false);
		}

		function getUser(username){
			return self.remote.getUser(username, function (err, response) {
				if (err) {
					if (err.name === 'not_found') {
						// typo, or you don't have the privileges to see this user
					} else {
						// some other error
					}
				} else {
					// response is the user object
					return response;
				}
			});
		}

		function findAllGrapes(){
			return findByType('grape')
				.then(function(grapes){
					return pluckCollection(grapes, [
						'_id',
						'category',
						'name'
					]);
				});
		}

		function pluckCollection(collection, keys){

			return lodash.map(collection, function(o){
				return lodash.pick(o, keys);
			});
		}

        /**
         * @return Promise
         */
        function destroy(){
            if (self.local){
                $log.debug('Destroying systemPouch db...');
                return self.local.destroy().catch(function(err){
                	$log.error('Error destroying systemPouch', err);
				});
            }

            return $q.when(false);
        }

		// exposed, public API
		return {
            destroy: destroy,
			getApiURL: getApiURL,
			getUser: getUser,
			remote: getRemoteDatabase,
			db: getLocalDatabase,
			getSyncHandler: getSyncHandler,
			findAllGrapes: findAllGrapes,
			"fetch": function(type){
				return findByType(type);
			},
			cancelReplication: cancelReplication,
			startReplication: startReplication
		};
	}

})();
